import React from "react";
import { Input, Row } from "reactstrap";
import { ColPrompt } from "./index";
import { ColValue, ErrorDiv } from "../ProductionModule/index";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
// Used by the Gilbos Doubler, SSM Kingspool, Taining 35A FP/AR/Tube machines, and the UT50/60

export default function ProgramRow({ hash = false }) {
   const { handleInputRangeChange } = useMachineSetupContextUpdater();
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();
   const defaultOnChangeVal = { target: { value: "" } };
   return (
      <Row className="mb-2">
         <ColPrompt title={hash ? "Program #" : "Program"} bold={true} />
         <ColValue size={4}>
            <Input
               type="text"
               style={{ borderRadius: "10px", fontSize: "14px" }}
               value={machineSetup.extendedPropertyJson.program || ""}
               onChange={(e) =>
                  e.target.value
                     ? handleInputRangeChange(e, 1, 99999, "program")
                     : handleInputRangeChange(defaultOnChangeVal, 1, 99999, "program")
               }
            />
            {machineSetup.machineType !== 7 && errorDivDefinitions.program && <ErrorDiv>1-99999 only</ErrorDiv>}
         </ColValue>
      </Row>
   );
}
